<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
          <h1 class="title is-size-3 mgt-20px">
            {{ $t('renouvellementCommande.popUpMotifNonRenouvellement.title') }}
          </h1>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <b-field :label="$t('renouvellementCommande.popUpMotifNonRenouvellement.motif')">
        <b-input v-model="motif" type="textarea">
        </b-input>
      </b-field>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('addEditContratNature.actions.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="changeEtatNonRenouvelee()">
              {{ $t('general.button.valider') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { nonRenouvelee } from '@/api/commande';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/commande/renouvellement/renouvellementChampsTranslator';

export default {
  name: 'popUpMotifNonRenouvellement',
  components: {
    ErrorMsgComponent,
  },
  props: {
    commandeIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      motif: null,
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  methods: {
    async changeEtatNonRenouvelee() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await nonRenouvelee({
          commandeIds: this.commandeIds,
          motifNonRenouvellement: this.motif,
        });
        this.$parent.close();
        loadingComponent.close();
        messageSucces(this.commandeIds.length > 1
          ? this.$i18n.t('renouvellementCommande.messages.success.changeEtatNePasRenouvelerMultiCommande')
          : this.$i18n.t('renouvellementCommande.messages.success.changeEtatNePasRenouveler'));
        this.$emit('recherche');
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
      }
    },
  },
};
</script>

<style scoped>

</style>
